/**
 * Backend money (`"245.00"`, a decimal string) to the panel's integer cents.
 *
 * The only crossing between the two formats, so no float ever takes part: the integer and the
 * fraction are read as text and combined with integer arithmetic. A string that is not a plain
 * decimal with up to two places is refused with a `RangeError`, never turned into a silent
 * `NaN` that would sum to a wrong total with the appearance of a right one.
 */

const DECIMAL_PATTERN = /^(-)?(\d+)(?:\.(\d{1,2}))?$/;

export function decimalStringToCents(decimal: string): number {
  const match = DECIMAL_PATTERN.exec(decimal);

  if (match === null) {
    throw new RangeError(`decimalStringToCents: not a decimal with up to two places: ${JSON.stringify(decimal)}`);
  }

  const [, sign, integer, fraction = ""] = match;
  const cents = Number(integer) * 100 + Number(fraction.padEnd(2, "0"));

  return sign === "-" ? -cents : cents;
}
